import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X, ChevronDown, Calendar, ShieldAlert, Lock, ArrowRight } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/ui/FadeIn';
import { MentorshipProcessSection } from '../components/MentorshipProcessSection';
const faqs = [{
  q: '¿Cuándo inicia y cuánto dura?',
  a: 'Inicia en Abril 2026 y tiene una duración exacta de 3 meses de acompañamiento intensivo.'
}, {
  q: '¿Las clases quedan grabadas?',
  a: 'Sí, todas las clases en vivo (sábados cada 15 días) y sesiones de Q&A quedan grabadas para que las repases cuando quieras.'
}, {
  q: '¿Cómo funciona el precio de alumno (USD 399)?',
  a: 'Si ya compraste previamente el Pack completo, obtendrás un descuento de Alumno. Solo debes contactar a soporte para validar tu compra y recibir el link de pago con descuento.'
}, {
  q: '¿Incluye señales de trading?',
  a: 'NO. El objetivo de esta mentoría es formarte para que no dependas de nadie. Aprenderás a leer el mercado y tomar tus propias decisiones.'
}, {
  q: '¿Es asesoramiento financiero?',
  a: 'No. Todo el contenido y las correcciones son estrictamente educativos. No damos recomendaciones de inversión.'
}, {
  q: '¿Qué métodos de pago aceptan?',
  a: 'Aceptamos USDT (cripto), Wise (USD) y transferencia en ARS (al tipo de cambio crypto del día, consultar por soporte).'
}];
export function MentoriaPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <div className="min-h-screen bg-neutral-950 text-white selection:bg-red-500/30 selection:text-white overflow-x-hidden" data-id="element-350">
      <Navbar data-id="element-351" />

      <main data-id="element-352">
        {/* HERO SECTION */}
        <section className="relative pb-12 md:pb-16 overflow-hidden bg-neutral-950" style={{
        paddingTop: 'calc(var(--header-height) + 80px)'
      }} data-id="element-353">
          <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-10" data-id="element-354">
            <div className="w-[1px] h-screen bg-red-500 absolute left-1/2 -translate-x-1/2" data-id="element-355" />
            <div className="h-[1px] w-screen bg-red-500 absolute top-1/2 -translate-y-1/2" data-id="element-356" />
          </div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#0a0a0a_80%)] pointer-events-none" data-id="element-357" />

          <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-358">
            <FadeIn data-id="element-359">
              <div className="inline-flex items-center gap-2 bg-red-600/10 border border-red-600/20 px-3 sm:px-4 py-2 rounded-sm mb-8 max-w-full flex-wrap justify-center" data-id="element-360">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse shrink-0" data-id="element-361" />
                <span className="text-[10px] sm:text-xs font-bold tracking-[0.1em] sm:tracking-[0.2em] text-red-500 uppercase text-center" data-id="element-362">
                  Inicio: Abril 2026 — Cupos limitados
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-363">
              <h1 className="text-4xl sm:text-5xl md:text-7xl font-black tracking-tighter text-white mb-8 leading-[1.05] uppercase break-words" data-id="element-364">
                Mentoría Privada
                <br data-id="element-365" />
                <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-neutral-500 pb-1 inline-block" data-id="element-366">
                  Protocolo Sniper
                </span>
                <br data-id="element-367" />
                <span className="text-xl sm:text-3xl md:text-5xl text-neutral-600" data-id="element-368">
                  (3 meses)
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-369">
              <p className="text-lg md:text-xl text-neutral-300 max-w-3xl mx-auto mb-12 text-balance" data-id="element-370">
                Todo el sistema + acompañamiento + correcciones + comunidad.{' '}
                <strong className="text-white font-medium border-b border-red-600" data-id="element-371">
                  Sin dependencia.
                </strong>
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-372">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-373">
                <button onClick={() => document.getElementById('precio')?.scrollIntoView({
                behavior: 'smooth'
              })} className="inline-block bg-red-600 hover:bg-red-500 text-white font-bold py-5 px-8 sm:px-12 rounded-sm transition-all uppercase tracking-wider text-sm shadow-[0_0_30px_rgba(220,38,38,0.3)] w-full sm:w-auto" data-id="element-374">
                  Ver Precio y Reservar
                </button>
                <button onClick={() => document.getElementById('proceso')?.scrollIntoView({
                behavior: 'smooth'
              })} className="inline-block bg-transparent border border-neutral-700 hover:border-neutral-500 hover:bg-neutral-800 text-white font-bold py-5 px-8 sm:px-12 rounded-sm transition-all uppercase tracking-wider text-sm w-full sm:w-auto" data-id="element-375">
                  Ver el proceso
                </button>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* PROCESO DE MENTORÍA */}
        <MentorshipProcessSection data-id="element-376" />

        {/* TRUST BANNER */}
        <section className="py-12 bg-neutral-950 border-b border-neutral-900" data-id="element-377">
          <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-378">
            <FadeIn data-id="element-379">
              <div className="bg-[#121212] border border-red-600/30 rounded-sm p-6 md:p-8 text-center shadow-[0_0_30px_rgba(220,38,38,0.05)]" data-id="element-380">
                <p className="text-white font-bold uppercase tracking-widest text-xs md:text-sm flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6" data-id="element-381">
                  <span className="flex items-center gap-2" data-id="element-382">
                    <Check className="w-4 h-4 text-red-500 shrink-0" data-id="element-383" /> Inicio:
                    Abril 2026
                  </span>
                  <span className="hidden md:inline text-neutral-700" data-id="element-384">•</span>
                  <span className="flex items-center gap-2" data-id="element-385">
                    <Check className="w-4 h-4 text-red-500 shrink-0" data-id="element-386" /> Cupos
                    limitados
                  </span>
                  <span className="hidden md:inline text-neutral-700" data-id="element-387">•</span>
                  <span className="flex items-center gap-2" data-id="element-388">
                    <Check className="w-4 h-4 text-red-500 shrink-0" data-id="element-389" />{' '}
                    Comunidad privada
                  </span>
                  <span className="hidden md:inline text-neutral-700" data-id="element-390">•</span>
                  <span className="flex items-center gap-2" data-id="element-391">
                    <Check className="w-4 h-4 text-red-500 shrink-0" data-id="element-392" /> Práctica
                    guiada semanal
                  </span>
                </p>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* BLOQUE PRECIO */}
        <section id="precio" className="py-24 md:py-32 bg-neutral-900 border-b border-neutral-800 relative" data-id="element-393">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-394">
            <FadeIn data-id="element-395">
              <div className="text-center mb-16" data-id="element-396">
                <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-4 block" data-id="element-397">
                  Inversión
                </span>
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tight uppercase break-words" data-id="element-398">
                  Asegurá tu lugar
                </h2>
              </div>
            </FadeIn>

            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-399">
              {/* Precio Estándar */}
              <FadeIn delay={0.1} data-id="element-400">
                <div className="bg-[#121212] border border-neutral-800 p-8 md:p-10 rounded-sm flex flex-col h-full relative" data-id="element-401">
                  <h3 className="text-xl font-bold text-white mb-2 uppercase tracking-wide" data-id="element-402">
                    Ingreso Estándar
                  </h3>
                  <p className="text-neutral-400 text-sm mb-6" data-id="element-403">
                    Para nuevos alumnos que ingresan directamente a la mentoría.
                  </p>
                  <div className="mb-8" data-id="element-404">
                    <span className="text-5xl font-black text-white" data-id="element-405">
                      USD 500
                    </span>
                  </div>
                  <div className="mt-auto" data-id="element-406">
                    <a href="https://forms.gle/mr2T87PjtcX8RQ576" target="_blank" rel="noopener noreferrer" className="block w-full bg-red-600 hover:bg-red-500 text-white font-bold py-4 px-6 rounded-sm transition-all uppercase tracking-wider text-sm text-center leading-tight" data-id="element-407">
                      Confirmar mi cupo
                      <span className="block text-[0.85em] mt-1.5 whitespace-nowrap opacity-90" data-id="element-408">
                        (USD 500)
                      </span>
                    </a>
                    <p className="text-xs text-neutral-400 font-medium mt-3 leading-relaxed text-center" data-id="element-409">
                      Completá el formulario y te contactamos para confirmar
                      disponibilidad y coordinar el pago.
                    </p>
                  </div>
                </div>
              </FadeIn>

              {/* Precio Alumno */}
              <FadeIn delay={0.2} data-id="element-410">
                <div className="bg-[#0f0f0f] border border-red-600/30 p-8 md:p-10 rounded-sm flex flex-col h-full relative shadow-[0_0_40px_rgba(220,38,38,0.05)]" data-id="element-411">
                  <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-red-600 to-transparent" data-id="element-412" />
                  <div className="absolute -top-3 right-8 bg-red-600 text-white text-[10px] font-bold px-3 py-1 uppercase tracking-widest rounded-sm" data-id="element-413">
                    Descuento Aplicado
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2 uppercase tracking-wide" data-id="element-414">
                    Precio Alumno
                  </h3>
                  <p className="text-neutral-400 text-sm mb-6" data-id="element-415">
                    Si ya compraste el Ebook o el Pack (requiere validación por
                    soporte).
                  </p>
                  <div className="mb-8" data-id="element-416">
                    <span className="text-5xl font-black text-white" data-id="element-417">
                      USD 399
                    </span>
                  </div>
                  <div className="mt-auto" data-id="element-418">
                    <a href="https://forms.gle/mr2T87PjtcX8RQ576" target="_blank" rel="noopener noreferrer" className="block w-full bg-transparent border border-red-600 hover:bg-red-600/10 text-white font-bold py-4 px-6 rounded-sm transition-all uppercase tracking-wider text-sm text-center leading-tight" data-id="element-419">
                      Solicitar cupo alumno
                      <span className="block text-[0.85em] mt-1.5 whitespace-nowrap opacity-90" data-id="element-420">
                        (USD 399)
                      </span>
                    </a>
                    <p className="text-xs text-neutral-400 font-medium mt-3 leading-relaxed text-center" data-id="element-421">
                      Completá el formulario y te contactamos para confirmar
                      disponibilidad y coordinar el pago.
                    </p>
                  </div>
                </div>
              </FadeIn>
            </div>

            <FadeIn delay={0.3} data-id="element-422">
              <div className="max-w-4xl mx-auto mt-12 bg-neutral-950/50 border border-neutral-800 p-6 rounded-sm flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-423">
                <div className="flex items-center gap-4" data-id="element-424">
                  <ShieldAlert className="text-neutral-500 w-6 h-6 shrink-0" data-id="element-425" />
                  <div data-id="element-426">
                    <h4 className="text-white font-bold text-sm uppercase tracking-wide mb-1" data-id="element-427">
                      Medios de pago aceptados
                    </h4>
                    <p className="text-neutral-400 text-sm" data-id="element-428">
                      USDT (Cripto), Wise (USD) o ARS (equivalente al cambio
                      crypto del día / consultar).
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* PARA QUIÉN ES / NO ES */}
        <section className="py-24 md:py-32 bg-neutral-950 border-b border-neutral-900" data-id="element-429">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-430">
            <FadeIn data-id="element-431">
              <div className="text-center mb-16" data-id="element-432">
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tight uppercase break-words" data-id="element-433">
                  Filtro de Ingreso
                </h2>
              </div>
            </FadeIn>

            <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-434">
              <FadeIn delay={0.1} data-id="element-435">
                <div className="bg-[#121212] border border-neutral-800 p-8 rounded-sm" data-id="element-436">
                  <div className="flex items-center gap-3 mb-8 pb-6 border-b border-neutral-800" data-id="element-437">
                    <div className="w-10 h-10 bg-green-500/10 flex items-center justify-center rounded-sm" data-id="element-438">
                      <Check className="text-green-500 w-5 h-5" data-id="element-439" />
                    </div>
                    <h3 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-440">
                      Para quién ES
                    </h3>
                  </div>
                  <ul className="space-y-4" data-id="element-441">
                    {['Traders cansados de saltar de estrategia en estrategia.', 'Quienes buscan entender el por qué detrás de cada movimiento.', 'Personas dispuestas a estudiar, hacer backtesting y enviar capturas.', 'Quienes buscan un proceso real, sin atajos ni promesas de riqueza rápida.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-442">
                        <Check className="text-green-500 w-5 h-5 shrink-0 mt-0.5" data-id="element-443" />
                        <span className="text-neutral-300 text-sm leading-relaxed" data-id="element-444">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-445">
                <div className="bg-[#121212] border border-neutral-800 p-8 rounded-sm" data-id="element-446">
                  <div className="flex items-center gap-3 mb-8 pb-6 border-b border-neutral-800" data-id="element-447">
                    <div className="w-10 h-10 bg-red-500/10 flex items-center justify-center rounded-sm" data-id="element-448">
                      <X className="text-red-500 w-5 h-5" data-id="element-449" />
                    </div>
                    <h3 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-450">
                      Para quién NO ES
                    </h3>
                  </div>
                  <ul className="space-y-4" data-id="element-451">
                    {['Quienes buscan señales para copiar y pegar sin pensar.', 'Personas que quieren hacerse millonarias en un mes.', 'Quienes no tienen tiempo o ganas de sentarse a estudiar el gráfico.', 'Traders que buscan un "indicador mágico" que haga el trabajo por ellos.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-452">
                        <X className="text-red-500 w-5 h-5 shrink-0 mt-0.5" data-id="element-453" />
                        <span className="text-neutral-300 text-sm leading-relaxed" data-id="element-454">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* QUÉ INCLUYE */}
        <section className="py-24 md:py-32 bg-neutral-900 border-b border-neutral-800" data-id="element-455">
          <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-456">
            <FadeIn data-id="element-457">
              <div className="w-12 h-[2px] bg-red-600 mb-8" data-id="element-458" />
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tight uppercase mb-12 break-words" data-id="element-459">
                Qué incluye el programa
              </h2>
            </FadeIn>

            <div className="grid gap-4" data-id="element-460">
              {[{
              title: 'Lenguaje de Precio',
              desc: 'Fundamento completo para leer el mercado.'
            }, {
              title: 'Ebook Sniper OTC',
              desc: 'El manual operativo detallado.'
            }, {
              title: 'Tu Yo Perfecto para el Trading',
              desc: 'Módulo de mentalidad exclusivo de la mentoría.'
            }, {
              title: 'Clases en vivo',
              desc: 'Sábados cada 15 días (quedan grabadas).'
            }, {
              title: 'Correcciones en vivo',
              desc: 'Revisión de tus capturas y operativas para ajustar errores.'
            }, {
              title: 'Sesiones Q&A',
              desc: 'Espacio para resolver todas tus dudas operativas.'
            }, {
              title: 'Comunidad Privada',
              desc: 'Acceso por los 3 meses que dura el programa.'
            }, {
              title: 'Bonus Final',
              desc: 'Puente a Futuros (masterclass de introducción al Mercado de Futuros).'
            }].map((item, idx) => <FadeIn key={idx} delay={0.05 * idx} data-id="element-461">
                  <div className="bg-[#121212] border border-neutral-800 p-5 rounded-sm flex items-center gap-4 hover:border-neutral-600 transition-colors" data-id="element-462">
                    <div className="w-8 h-8 bg-neutral-900 flex items-center justify-center rounded-sm shrink-0 border border-neutral-800" data-id="element-463">
                      <Check className="text-red-500 w-4 h-4" data-id="element-464" />
                    </div>
                    <div data-id="element-465">
                      <h4 className="text-white font-bold uppercase tracking-wide text-sm" data-id="element-466">
                        {item.title}
                      </h4>
                      <p className="text-neutral-400 text-sm" data-id="element-467">{item.desc}</p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* DIFERENCIAL SIN DEPENDENCIA */}
        <section className="py-24 md:py-32 bg-neutral-950 border-b border-neutral-900" data-id="element-468">
          <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-469">
            <FadeIn data-id="element-470">
              <div className="border-l-2 border-red-600 pl-6 md:pl-10" data-id="element-471">
                <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-4 block" data-id="element-472">
                  El Diferencial
                </span>
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tight uppercase mb-6 leading-tight break-words" data-id="element-473">
                  El objetivo es que <br className="hidden md:block" data-id="element-474" />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-700" data-id="element-475">
                    no me necesites
                  </span>
                </h2>
                <div className="prose prose-invert prose-lg max-w-none text-neutral-400" data-id="element-476">
                  <p data-id="element-477">
                    La industria del trading está diseñada para mantenerte
                    pagando suscripciones mensuales por señales o indicadores.
                    Protocolo Sniper hace exactamente lo contrario.
                  </p>
                  <p data-id="element-478">
                    Estos 3 meses de acompañamiento intensivo tienen un solo
                    propósito: <strong data-id="element-479">instalar el sistema en tu cabeza</strong>
                    . Te corrijo, te guío y te doy feedback constante para que,
                    al terminar el programa, tengas el criterio absoluto para
                    sentarte frente al gráfico y operar por tu cuenta.
                    <strong className="text-white" data-id="element-480">
                      {' '}
                      Sin depender de mí, ni de nadie.
                    </strong>
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* SCRIPT ASISTENTE VISUAL */}
        <section className="py-24 md:py-32 bg-neutral-900 border-b border-neutral-800" data-id="element-481">
          <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-482">
            <FadeIn data-id="element-483">
              <div className="bg-[#0f0f0f] border border-neutral-800 p-8 md:p-12 rounded-sm relative overflow-hidden" data-id="element-484">
                <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/5 rounded-full blur-3xl pointer-events-none" data-id="element-485" />

                <div className="flex flex-col md:flex-row gap-8 items-start md:items-center" data-id="element-486">
                  <div className="w-16 h-16 bg-neutral-950 border border-neutral-800 flex items-center justify-center rounded-sm shrink-0" data-id="element-487">
                    <Lock className="w-8 h-8 text-red-500" data-id="element-488" />
                  </div>

                  <div className="flex-1" data-id="element-489">
                    <div className="flex flex-wrap items-center gap-3 mb-3" data-id="element-490">
                      <h3 className="text-2xl font-black text-white uppercase tracking-tight" data-id="element-491">
                        Asistente Visual Sniper
                      </h3>
                      <span className="text-[10px] font-bold tracking-wider bg-red-600/10 text-red-500 px-2 py-1 rounded-sm border border-red-600/20 uppercase" data-id="element-492">
                        Se libera por mérito
                      </span>
                    </div>

                    <p className="text-neutral-400 text-sm md:text-base leading-relaxed mb-4" data-id="element-493">
                      Esta herramienta exclusiva de la mentoría{' '}
                      <strong className="text-white" data-id="element-494">
                        NO es un indicador mágico y NO opera por vos
                      </strong>
                      . Su función es acelerar la lectura del gráfico y reducir
                      errores comunes (como buscar entradas donde no las hay).
                    </p>
                    <p className="text-neutral-500 text-sm italic" data-id="element-495">
                      * Se entrega únicamente cuando el alumno demuestra que
                      domina las confirmaciones manualmente. No antes.
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>

        {/* CUPOS + CTA FINAL */}
        <section className="py-24 md:py-32 bg-neutral-950 border-b border-neutral-900 text-center" data-id="element-496">
          <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-497">
            <FadeIn data-id="element-498">
              <div className="inline-flex items-center gap-3 mb-8 bg-neutral-900 border border-neutral-800 px-6 py-3 rounded-sm" data-id="element-499">
                <Calendar className="text-red-500 w-5 h-5" data-id="element-500" />
                <span className="text-white font-bold uppercase tracking-wide" data-id="element-501">
                  Inicio: Abril 2026
                </span>
              </div>

              <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-white tracking-tight uppercase mb-8 break-words" data-id="element-502">
                Cupos Limitados
              </h2>

              <p className="text-neutral-400 text-lg mb-12" data-id="element-503">
                Para garantizar la calidad de las correcciones y el seguimiento
                personalizado, las inscripciones se cierran automáticamente al
                completarse el cupo.
              </p>

              <button onClick={() => document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            })} className="inline-block bg-red-600 hover:bg-red-500 text-white font-bold py-5 px-12 rounded-sm transition-all uppercase tracking-wider text-sm shadow-[0_0_30px_rgba(220,38,38,0.3)]" data-id="element-504">
                Ver Precio y Reservar
              </button>
            </FadeIn>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-24 md:py-32 bg-neutral-900" data-id="element-505">
          <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-506">
            <FadeIn data-id="element-507">
              <div className="text-center mb-16" data-id="element-508">
                <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-4 block" data-id="element-509">
                  Dudas Comunes
                </span>
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tight uppercase break-words" data-id="element-510">
                  FAQ Mentoría
                </h2>
              </div>
            </FadeIn>

            <div className="space-y-4" data-id="element-511">
              {faqs.map((faq, idx) => <FadeIn key={idx} delay={0.05 * idx} data-id="element-512">
                  <div className="border border-neutral-800 bg-[#121212] rounded-sm overflow-hidden" data-id="element-513">
                    <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-514">
                      <span className="font-bold text-white pr-8" data-id="element-515">{faq.q}</span>
                      <ChevronDown className={`w-5 h-5 text-neutral-500 transition-transform duration-300 shrink-0 ${openFaq === idx ? 'rotate-180 text-red-500' : ''}`} data-id="element-516" />
                    </button>
                    <AnimatePresence data-id="element-517">
                      {openFaq === idx && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3,
                    ease: 'easeInOut'
                  }} data-id="element-518">
                          <div className="px-6 pb-6 text-neutral-400 text-sm leading-relaxed border-t border-neutral-800/50 pt-4" data-id="element-519">
                            {faq.a}
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-520" />
    </div>;
}